import React, { useState, useEffect, useRef } from "react";
import { Download } from "lucide-react";

const Collection = () => {

  useEffect(() => {
  try {
    const adEl = document.querySelector(".adsbygoogle");
    if (adEl && !adEl.getAttribute("data-adsbygoogle-status")) {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }
  } catch (e) {
    console.error("AdSense error:", e);
  }
}, []);

  return (
    <div className="downloads-container fade-in-up">
      <h1 className="section-title" style={{ marginBottom: "28px" }}>
        My Collection
      </h1>

      <div className="downloads-empty">
        <div className="empty-icon">
          <Download size={44} />
        </div>
        <h3 className="empty-title">No Downloads Yet</h3>
        <p className="empty-text">
          Download restored heritage films to watch offline.
          <br />
          Your collection will appear here.
        </p>
      </div>

      {/* ✅ Ad banner inside the single return, at the bottom */}
      <ins className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-XXXXXXXX"
        data-ad-slot="XXXXXXXX"
        data-ad-format="auto">
      </ins>
    </div>
  );
};

export default Collection;